// acciones
export const SAGA_INITIAL_STATE = "catalogoReducer/SAGA_INITIAL_STATE";
export const SAGA_INITIAL_STATE_RELOAD_ALL = "catalogoReducer/SAGA_INITIAL_STATE_RELOAD_ALL";

export const SAGA_SAVE_CATALOGO = "catalogoReducer/SAGA_SAVE_CATALOGO";
export const SET_IDCATALOGO = "catalogoReducer/SET_IDCATALOGO";

export const SAGA_GET_CATALOGO_NAME = "catalogoReducer/SAGA_GET_CATALOGO_NAME";
export const SET_CATALOGOS = "catalogoReducer/SET_CATALOGOS";

export const SAGA_GET_IMAGEN_CATALOGO = "catalogoReducer/SAGA_GET_IMAGEN_CATALOGO";
export const SET_IMAGEN_CATALOGO = "catalogoReducer/SET_IMAGEN_CATALOGO";

export const SAGA_SAVE_IMAGEN_CATALOGO_TEMPORAL =
  "catalogoReducer/SAGA_SAVE_IMAGEN_CATALOGO_TEMPORAL";

export const SAGA_GET_CATALOGO_COMPLETO_ID = "catalogoReducer/SAGA_GET_CATALOGO_COMPLETO_ID";
export const SET_CATALOGO_COMPLETO = "catalogoReducer/SET_CATALOGOS_COMPLETO";

export const SAGA_GET_IMAGENES_ARTICULO = "catalogoReducer/SAGA_GET_IMAGENES_ARTICULO";
export const SET_IMAGENES_ARTICULO = "catalogoReducer/SET_IMAGENES_ARTICULO";
export const REMOVE_IMAGENES_ARTICULO = "catalogoReducer/REMOVE_IMAGENES_ARTICULO";
export const SET_IMAGENES_ACTUALIZADAS = "catalogoReducer/SET_IMAGENES_ACTUALIZADAS";

export const SAGA_GET_PUBLICADOS = "catalogoReducer/SAGA_GET_PUBLICADOS";
export const SET_PUBLICADOS = "catalogoReducer/SET_PUBLICADOS";
export const SET_SELECTED = "catalogoReducer/SET_SELECTED";

export const SAGA_SAVE_PUBLICAR_CATALOGO = "catalogoReducer/SAGA_SAVE_PUBLICAR_CATALOGO";
export const SAGA_SAVE_OCULTAR_CATALOGO = "catalogoReducer/SAGA_SAVE_OCULTAR_CATALOGO";
export const SAGA_SAVE_BORRAR_CATALOGO = "catalogoReducer/SAGA_SAVE_BORRAR_CATALOGO";
export const SAGA_CAMBIAR_ORDEN_CATALOGO_ENTRADA =
  "catalogoReducer/SAGA_CAMBIAR_ORDEN_CATALOGO_ENTRADA";

export const SAGA_SAVE_CATALOGO_IMAGEN = "catalogoReducer/SAGA_SAVE_CATALOGO_IMAGEN";
export const SAGA_TRASLADAR_CATALOGO = "catalogoReducer/SAGA_TRASLADAR_CATALOGO";

//PARA ACTUALIZAR SOLO EL CATALOGO COMPELTO
export const SET_CATALOGO_COMPLETO_AUX = "catalogoReducer/SET_CATALOGO_COMPLETO_AUX";

//PARA BORRAR UN ARTICULO DEL CATALOGO COMPLETO
export const BORRAR_ARTICULO_CATALOGO_COMPLETO =
  "catalogoReducer/BORRAR_ARTICULO_CATALOGO_COMPLETO";

export const ADD_ARTICULO_CATALOGO_COMPLETO = "catalogoReducer/ADD_ARTICULO_CATALOGO_COMPLETO";

export const SAGA_GET_CATALOGO_COMPLETO_AUXILIAR =
  "catalogoReducer/SAGA_GET_CATALOGO_COMPLETO_AUXILIAR";
//Me sirve para actuaizar el catalogo completo, experimental.
export const SET_CATALOGO_COMPLETO_AUXILIAR = "catalogoReducer/SAGA_GET_CATALOGO_COMPLETO_AUXILIAR";

export const ADD_ARTICULO_CATALOGO = "articuloReducer/ADD_ARTICULO_CATALOGO";

export const CAMBIAR_ARTICULO_DE_SUBRUBRO = "catalogoReducer/CAMBIAR_ARTICULO_DE_SUBRUBRO";

// funciones

export const addArticuloCatalogo = (payload) => ({
  type: ADD_ARTICULO_CATALOGO,
  payload,
});

export const sagaInitialState = () => ({
  type: SAGA_INITIAL_STATE,
});

export const sagaInitialStateReloadAll = () => ({
  type: SAGA_INITIAL_STATE_RELOAD_ALL,
});

export const sagaSaveCatalogo = (payload) => ({
  type: SAGA_SAVE_CATALOGO,
  payload,
});

export const sagaCambiarOrdenCatalogoEntrada = (payload) => ({
  type: SAGA_CAMBIAR_ORDEN_CATALOGO_ENTRADA,
  payload,
});

export const sagaGetCatalogoByName = (payload) => ({
  type: SAGA_GET_CATALOGO_NAME,
  payload,
});

export const sagaGetImagenCatalogo = (payload) => ({
  type: SAGA_GET_IMAGEN_CATALOGO,
  payload,
});

export const setImagenCatalogo = (payload) => ({
  type: SET_IMAGEN_CATALOGO,
  payload,
});

export const setImagenCatalogoToTemp = (payload) => ({
  type: SAGA_SAVE_IMAGEN_CATALOGO_TEMPORAL,
  payload,
});

export const setCatalogos = (payload) => ({
  type: SET_CATALOGOS,
  payload,
});

export const sagaGetPublicados = () => ({
  type: SAGA_GET_PUBLICADOS,
});

export const setPublicados = (payload) => ({
  type: SET_PUBLICADOS,
  payload,
});

export const sagaGetCatalogoCompleto = (payload) => ({
  type: SAGA_GET_CATALOGO_COMPLETO_ID,
  payload,
});

export const setCatalogoCompleto = (payload) => ({
  type: SET_CATALOGO_COMPLETO,
  payload,
});

export const sagaGetImagenesArticulo = (payload) => ({
  type: SAGA_GET_IMAGENES_ARTICULO,
  payload,
});

export const setImagenesArticulo = (payload) => ({
  type: SET_IMAGENES_ARTICULO,
  payload,
});

export const removeImagenesArticulo = (payload) => ({
  type: REMOVE_IMAGENES_ARTICULO,
  payload,
});

export const setImagenesActualizadas = (payload) => ({
  type: SET_IMAGENES_ACTUALIZADAS,
  payload,
});

export const setSelectedCatalogo = (payload) => ({
  type: SET_SELECTED,
  payload,
});

export const setIdCatalogo = (payload) => ({
  type: SET_IDCATALOGO,
  payload,
});

export const sagaSavePublicarCatalogo = (payload) => ({
  type: SAGA_SAVE_PUBLICAR_CATALOGO,
  payload,
});

export const sagaSaveOcultarCatalogo = (payload) => ({
  type: SAGA_SAVE_OCULTAR_CATALOGO,
  payload,
});

export const sagaSaveBorrarCatalogo = (payload) => ({
  type: SAGA_SAVE_BORRAR_CATALOGO,
  payload,
});

export const sagaSaveImagenCatalogo = (payload) => ({
  type: SAGA_SAVE_CATALOGO_IMAGEN,
  payload,
});

export const sagaTrasladarCatalogo = (payload) => ({
  type: SAGA_TRASLADAR_CATALOGO,
  payload,
});

export const setCatalogoCompletoAux = (payload) => ({
  type: SET_CATALOGO_COMPLETO_AUX,
  payload,
});

export const borrarArticuloDeCatalogoCompleto = (payload) => ({
  type: BORRAR_ARTICULO_CATALOGO_COMPLETO,
  payload,
});

export const agregarArticuloACatalogoCompleto = (payload) => ({
  type: ADD_ARTICULO_CATALOGO_COMPLETO,
  payload,
});

export const sagaGetCatalogoCompletoAuxiliar = (payload) => ({
  type: SAGA_GET_CATALOGO_COMPLETO_AUXILIAR,
  payload,
});

///seguir
export const setCatalogoCompletoAuxiliar = (payload) => ({
  type: SET_CATALOGO_COMPLETO_AUXILIAR,
  payload,
});

export const cambiarArticuloDeSubRubro = (payload) => ({
  type: CAMBIAR_ARTICULO_DE_SUBRUBRO,
  payload,
});
